import { GetterTree } from 'vuex';

import { ToastStateI } from './state';
import { RootStateI } from '../state';

const getters: GetterTree<ToastStateI, RootStateI> = {
  getMessage: (state) => state.message,
  getType: (state) => state.type,
  getTimeout: (state) => state.timeout,
  getShow: (state) => state.show,
};

export default getters;
